import * as tslib_1 from "tslib";
import { KeyControlAndAbstractSearchCriteria } from './key-control-and-abstract-search-criteria';
var BrandSearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(BrandSearchCriteria, _super);
    function BrandSearchCriteria() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.code = '';
        _this.name = '';
        _this.kcCompany = '';
        return _this;
    }
    return BrandSearchCriteria;
}(KeyControlAndAbstractSearchCriteria));
export { BrandSearchCriteria };
